import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SideMenuTtgComponent} from './side-menu-ttg/side-menu-ttg.component';
import {ContentHolderComponent} from './content-holder/content-holder.component';
import {MatDividerModule} from '@angular/material/divider';
import {UserInformationComponent} from './side-menu-ttg/user-information/user-information.component';
import {SideMenuServices} from './side-menu-ttg/side-menu.service';
import {MatExpansionModule} from '@angular/material/expansion';
import {SearchHighlightPipe} from './pipes/search-highlight.pipe';
import { MatTooltipModule } from '@angular/material/tooltip';
import {FileUploadComponent} from './file-upload/file-upload.component';
import {FileUploadService} from './file-upload/file-upload.service';
import {FlexModule} from '@angular/flex-layout';



@NgModule({
    imports: [
        CommonModule,
        MatDividerModule,
        MatExpansionModule,
        MatTooltipModule,
        FlexModule
    ],

    declarations: [
        SideMenuTtgComponent,
        ContentHolderComponent,
        UserInformationComponent,
        SearchHighlightPipe,
        FileUploadComponent,
    ],

    exports: [
        SideMenuTtgComponent,
        ContentHolderComponent,
        UserInformationComponent,
        SearchHighlightPipe,
        FileUploadComponent,
    ],

    providers: [
        SideMenuServices, FileUploadService
    ]


})
export class UiModule {
}
